import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import { arrowTag } from 'styled-system/recipes';

/** The ↗ badge that pops in when its card (`.group`) is hovered. */
export function ArrowTag() {
  return (
    <span className={arrowTag()} aria-hidden>
      <ArrowUpRight />
    </span>
  );
}
